'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _invalidCharsGroup = require('./invalidCharsGroup');

var _invalidCharsGroup2 = _interopRequireDefault(_invalidCharsGroup);

var _regexSupplant = require('../lib/regexSupplant');

var _regexSupplant2 = _interopRequireDefault(_regexSupplant);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Copyright 2018 Twitter, Inc.
// Licensed under the Apache License, Version 2.0
// http://www.apache.org/licenses/LICENSE-2.0

var invalidChars = (0, _regexSupplant2.default)(/[#{invalidCharsGroup}]/, {
  invalidCharsGroup: _invalidCharsGroup2.default
});
exports.default = invalidChars;
module.exports = exports['default'];